import {
  AssetDTO,
  BaseEntityDTO,
  BranchYearJudgeRoundDTO,
  IAssetDTO,
  IBaseEntityDTO,
  IBranchYearJudgeRoundDTO,
  IOrderDTO,
  IParticipantDTO,
  IReleaseDTO,
  ITeamCriteriaDTO,
  ParticipantDTO,
  ReleaseDTO,
  TeamCriteriaDTO,
} from './';

export interface ISubmissionDTO extends IBaseEntityDTO {
  participant?: IParticipantDTO;
  teamCriteria?: ITeamCriteriaDTO;
  title: string;
  director: string;
  screenshot?: IAssetDTO;
  movie?: IAssetDTO;
  teamVideo?: IAssetDTO;
  screeningCopy?: IAssetDTO;
  trailer?: IAssetDTO;
  bts?: IAssetDTO;
  genre: string;
  rating: string;
  running_time: string;
  logline: string;
  use_of_criteria: string;
  containsAdult: string;
  request_notes: boolean;
  releases: IReleaseDTO[];
  createdMusic: boolean;
  releasesDone: boolean;
  castAndCrew: string;
  order?: IOrderDTO;
  rounds?: IBranchYearJudgeRoundDTO[];
}

export class SubmissionDTO extends BaseEntityDTO implements ISubmissionDTO {
  participant?: IParticipantDTO;
  teamCriteria?: ITeamCriteriaDTO;
  title: string;
  director: string;
  screenshot?: IAssetDTO;
  movie?: IAssetDTO;
  teamVideo?: IAssetDTO;
  screeningCopy?: IAssetDTO;
  trailer?: IAssetDTO;
  bts?: IAssetDTO;
  genre: string;
  rating: string;
  running_time: string;
  logline: string;
  use_of_criteria: string;
  containsAdult: string;
  request_notes: boolean;
  releases: IReleaseDTO[];
  createdMusic: boolean;
  releasesDone: boolean;
  castAndCrew: string;
  rounds?: IBranchYearJudgeRoundDTO[];

  constructor(data?: Partial<SubmissionDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.participant = data?.participant ? new ParticipantDTO(data.participant) : undefined;
    this.teamCriteria = data?.teamCriteria ? new TeamCriteriaDTO(data.teamCriteria) : undefined;
    this.title = data?.title ?? '';
    this.director = data?.director ?? '';
    this.screenshot = data?.screenshot ? new AssetDTO(data.screenshot) : undefined;
    this.movie = data?.movie ? new AssetDTO(data.movie) : undefined;
    this.teamVideo = data?.teamVideo ? new AssetDTO(data.teamVideo) : undefined;
    this.trailer = data?.trailer ? new AssetDTO(data.trailer) : undefined;
    this.bts = data?.bts ? new AssetDTO(data.bts) : undefined;
    this.genre = data?.genre ?? '';
    this.rating = data?.rating ?? '';
    this.running_time = data?.running_time ?? '';
    this.logline = data?.logline ?? '';
    this.use_of_criteria = data?.use_of_criteria ?? '';
    this.containsAdult = data?.containsAdult ?? '';
    this.request_notes = data?.request_notes ?? false;
    this.createdMusic = data?.createdMusic ?? false;
    this.releasesDone = data?.releasesDone ?? false;
    this.castAndCrew = data?.castAndCrew ?? '';
    this.releases = data?.releases ? data.releases.map((release) => new ReleaseDTO(release)) : [];
    this.rounds = data?.rounds
      ? data.rounds.map((round) => new BranchYearJudgeRoundDTO(round))
      : [];
  }
}
